export const getIsoDateWithOffset = (date) => {
    return (date ?? new Date())
        .toLocaleString('sv', { timeZoneName: 'longOffset' })
        .replace(' ', 'T')
        .replace(' GMT', '');
};
export const getCurrentTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export const getOnlyDateFromIso = (dateIso) => {
    const splitDate = dateIso.split('T');
    return splitDate.length > 1 ? splitDate[0] : '';
};
//# sourceMappingURL=date.utils.js.map